<template>
    <div>
        <CRow>
            <CCol xs="12" sm="12" md="4" lg="4" xl="3">
                <CCard>
                    <CCardHeader class="d-flex justify-content-between">
                        <b><i class="fas fa-solid fa-award"></i>&nbsp;Productos</b>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="12">
                                <CSelect label="Sedes" :options="data_campus" placeholder="--Seleccione una sede --"
                                    :value.sync="selectedCampus" @change="onCampusChange" :disabled="cpDisabledCampu" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Total de registros" type="text" size="sm" v-model="totalCompras"
                                    disabled />
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol xs="12" sm="12" md="8" lg="8" xl="9">
                <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
                    caption="Lista de productos" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'">
                </CTableWrapper>
            </CCol>
        </CRow>

    </div>
</template>

<script>
const fields = [
    { key: "index", label: "ID", _style: "width:1%" },
    { key: "name_product", label: "Nombre del producto", _style: "width:10%;" },
    { key: "price_sale", label: "Precio de venta", _style: "width:10%;" },
    { key: "campus", label: "Sede", _style: "width:10%;" },
];

import CTableWrapper from "../../../shared/datatable/Table.vue";
import { mapActions } from "vuex";

export default {
    components: {
        CTableWrapper,

    },
    data() {
        return {
            prefix: "products",
            fields,
            data: [],
            rol_id: this.$store.getters.get_rol.id,
            data_campus: [],
            totalCompras: 0,
            componentKey: 0,
            selectedCampus: null,
        };
    },
    computed: {
        cpStatus: function () {
            if (this.companies.state == 1) return true;
            return false;
        },
        cpDisabledCampu() {
            if (this.rol_id == 4 || this.rol_id == 8) {
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        // this.mtd_data();
        this.getCampus();
        this.setDefaultCampus();
    },
    methods: {
        ...mapActions(["get", "post"]),
        getCampus() {
            this.get({
                url:
                    this.$store.getters.get__url +
                    "/stock_transfer/getCampus/" +
                    this.$store.getters.get_company.id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode == 200) {
                    this.data_campus = [
                        { label: "Todos", value: null },
                        ...response.data.map((element) => ({
                            label: element.name,
                            value: element.id,
                        })),
                    ];
                }
            });
        },
        setDefaultCampus() {
            if (this.rol_id === 4) {
                this.selectedCampus = null; // "Todos"
                this.onCampusChange();
            } else {
                this.selectedCampus = this.$store.getters.get_campu.id;
                this.onCampusChange();
            }
        },
        onCampusChange() {
            if (this.selectedCampus === null) {
                this.mtd_data();
            } else {
                this.mtd_data(this.selectedCampus);
            }
        },
        mtd_data(campuId = null) {
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/productPrice",
                token: this.$store.getters.get__token,
                params: {
                    campu_id: campuId,
                    company_id: this.$store.getters.get_company.id,
                },
            })
                .then((response) => {
                    this.clearData();
                    this.data = response.data;
                    this.totalCompras = this.data.length;
                    this.sumaTotalCompras = this.data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(2);
                    this.data.forEach((item) => {
                        item.name_product = item.name;
                        item.price_sale = item.price.length > 0 ? item.price[0].sale_price : 'Precio no registrado';
                        item.campus = item.campu.name;
                    });
                    let index = 1;
                    this.data.forEach((arr) => {
                        arr.index = index;
                        index++
                    });
                })
                .catch((errors) => {
                    Swal.fire({
                        title: errors,
                        icon: "danger",
                    });
                });
        },
        mtdBack: function () {
            this.$emit("returnHome");
        },
        clearData() {
            this.data = [];
            this.totalCompras = 0;
            this.sumaTotalCompras = 0;
        },
    },

};
</script>

<style lang="scss" scoped></style>